// external scripts
import $ from 'jquery';
import debug from 'bows';
import svg4everybody from 'svg4everybody';
import Dropdown from 'modernDropdown';
import Selectr from 'selectr';
import Cookies from 'cookies';

// example of ES2015 modules loading & tree shaking
import { emptyLinks, externalLinks } from './_links';

import { trackAllClicks } from './_analytics';
import breakpoints from './_breakpoints';
import throttle from './util/_throttle';
import fitvid from './_fitvid';
import NavSearch from './_nav-search';
import i18n from './_i18n';
import MobileMenu from './_mobile-menu';
import SearchFilter from './_search-filter';
import PlayworksNearYouMap from './_playworks-near-you-map';
// import PlayworksNearYou from './_playworks-near-you';
import Breadcrumb from './_breadcrumb';

import PlayworksNearYou from './_playworks-near-you';

import FeaturedVideo from './_featured-video';
// import MobileMenuRegional from './_mobile-menu';
import EventsFix from './_events-fix';

import loader from './util/_loader'

const log = debug('site');

class Site {
	constructor(opts) {
		this.opts = opts;
		if ( /complete|interactive/.test(document.readyState) ) {
			this.domReady();
		} else {
			document.addEventListener('DOMContentLoaded', () => this.domReady());
		}

		window.addEventListener('load', () => this.windowLoad());
	}

	domReady() {
		const log = debug('site:domReady');

		fitvid(); // initialize fitvid videos
		i18n(); // footer language selector
		svg4everybody(); // external svg sprites

		// national leg
		if (document.documentElement.classList.contains('national')) {
			this.national();
		} else if (document.documentElement.classList.contains('regional')) {
			this.regional();
		}
		this.buttons();
		this.featuredVideos();
		this.searchFilters();
		this.formAssembly();
		this.playworksNearYouMaps();
		this.footerNewsletter();
		this.rowVideoFix();

		this.analytics();
		this._breadcrumbs = Array.from(document.querySelectorAll('.breadcrumb')).map((b) => new Breadcrumb(b));

		$('header.header, footer.footer, div.sidebar').addClass('notranslate');

		window.addEventListener('resize', throttle(this.resize.bind(this), 1));

		log('dom.ready');
	}

	windowLoad() {
		const log = debug('site:windowLoad');
		log('window.onload');

		// example of ES2015 modules loading & tree shaking
		emptyLinks();
		externalLinks();
	}

	buttons() {
		const selectors = [
			'button[type="submit"]',
			'.button'
		];

		const charMap = {
			' ': '&nbsp;'
		}

		const nodes = Array.from(document.querySelectorAll(selectors.join(', ')));
		if (nodes.length === 0) {
			return;
		}

		nodes.forEach((node) => {
			// skip if already processed
			if (node.getAttribute('data-text')) {
				return;
			}

			const chars = node.textContent.trim().split('');
			if (chars.length < 1) {
				return;
			}

			node.setAttribute('data-text', node.textContent);
			node.innerHTML = chars.map((char) => `<span>${(charMap[char]) ? charMap[char] : char}</span>`).join('');
		});
	}

	national() {
		this.navSearch = new NavSearch(document.querySelector('.nav--utility .nav__search'), function () {
			if (!this.wrapperNode) {
				this.wrapperNode = document.querySelector('.nav--utility');
			}
			return this.wrapperNode.offsetWidth;
		});

		const primary = document.querySelector('.nav--primary');
		if (primary) {
			this.primaryDropdowns = Array.from(primary.querySelectorAll('.nav__menu-item--depth0.nav__menu-item--has-submenu')).map((parent) => {
				return new Dropdown(parent, {
					openClass: 'nav__menu-item--submenu-open',
					beforeOpen: function () {
						if (document.body.clientWidth < breakpoints.medium) {
							return false;
						}
					},
					afterOpen: function () {
						if (document.body.clientWidth < breakpoints.medium) {
							return;
						}

						if (primary.getBoundingClientRect().right < this.menu.getBoundingClientRect().right) {
							this.menu.classList.add('nav__menu--off-right');
						}
					}
				});
			});
		}
		this.mobileMenu = new MobileMenu.national();
	}

	regional() {
		this.navSearch = new NavSearch(document.querySelector('.header__search'), function () {
			const content = document.querySelector('.header__content');
			const logo = document.querySelector('.header__logo');
			const marginRight = parseInt(window.getComputedStyle(logo).marginRight, 10);
			return content.offsetWidth - logo.offsetWidth - marginRight;
		});

		const globalMenu = document.querySelector('.header__global-menu');
		if (globalMenu) {
			const globalMenuLink = globalMenu.querySelector('a[href="#global-menu"]');
			if (globalMenuLink) {
				globalMenuLink.addEventListener('click', (e) => {
					e.preventDefault();
					globalMenu.classList.toggle('menu--open');
				});
			}
		}

		this.mobileMenu = new MobileMenu.regional();
	}

	resize() {
		log('site resize');

		let event = new CustomEvent('site.resize', {
			cancelable: false,
			bubbles: false
		});

		window.dispatchEvent(event);
	}

	featuredVideos() {
		let videos = Array.from(document.querySelectorAll('.featured-media--video-external'));
		if (videos) {
			videos.forEach((node) => {
				new FeaturedVideo(node);
			});
		}
	}

	rowVideoFix() {
		const rowSC = $('.row-sc');
		if (rowSC.length) {
			rowSC.find('p:empty').remove();
		}

	}

	playworksNearYouMaps() {
		this.nearYou();
		this._maps = Array.from(document.querySelectorAll('.pny-map')).map((map) => new PlayworksNearYouMap(map));
	}

	nearYou() {

		const menuLookup = Array.from(document.querySelectorAll('.pny-lookup'));
		log(menuLookup);
		if (menuLookup) {
			this._nearYouMenu = menuLookup.map(menu => new PlayworksNearYou.nav(menu));
		}

		const components = Array.from(document.querySelectorAll('.pny-lookup--component'));
		if (components) {
			this._nearYouComponents = components.map(c => new PlayworksNearYou.component(c));
		}
	}

	searchFilters() {
		const filters = Array.from(document.querySelectorAll('.search-filters'));
		if (!filters) {
			return;
		}

		this._searchFilters = filters.map((filter) => new SearchFilter(filter, this.opts.wpJson));
	}

	formAssembly() {
		const forms = Array.from(document.querySelectorAll('.formassembly--custom'));
		const log = debug('form-assembly');

		const toTitleCase = function (str) {
			str = str || '';
			return str.toLowerCase().split(' ').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
		}

		forms.forEach((form) => {
			log(form);
			const selectrs = {};
			const cache = {};
			const recordMap = {};
			const nodes = {};
			const state = form.dataset.ncesState;
			const school = form.dataset.ncesSchool;
			const address = form.dataset.ncesAddress;
			const city = form.dataset.ncesCity;
			const zip = form.dataset.ncesZip;

			let schoolAddressName = null;
			let schoolSelectName = null;
			let stateSelectName = null;

			if (state && school && address) {
				nodes.state = form.querySelector(`[name="${state}"]`);
				nodes.school = form.querySelector(`[name="${school}"]`);
				nodes.address = form.querySelector(`[name="${address}"]`);
				nodes.city = form.querySelector(`[name="${city}"]`);
				nodes.zip = form.querySelector(`[name="${zip}"]`);

				log('nodes', nodes);

				if (nodes.state && nodes.school && nodes.address && nodes.city && nodes.zip) {
					const schoolSelect = document.createElement('select');
					schoolSelectName = nodes.school.name + '_select';
					schoolSelect.name = schoolSelectName;
					schoolSelect.placeholder = 'Please select a school';
					schoolSelect.insertAdjacentHTML('beforeend', '<option value="">Please select a state</option>');
					nodes.school.parentNode.insertBefore(schoolSelect, nodes.school);
					nodes.school.type = 'hidden';
				}
			}

			if (form.classList.contains('formassembly--custom-select')) {
				const selects = Array.from(form.querySelectorAll('select')).map((select) => {
					if (typeof selectrs[select.name] === 'undefined') {
						log('select', select);
						const selectrOptions = {
							defaultSelected: true
						};

						if (select.placeholder) {
							selectrOptions.placeholder = select.placeholder;
						}

						selectrs[select.name] = new Selectr(select, selectrOptions);

						selectrs[select.name].on('selectr.change', (option) => {
							if (option) {
								log('option1', option);
								select.dispatchEvent(new Event('change'));
							}
						});

						if (selectrs[schoolSelectName]) {
							selectrs[schoolSelectName].on('selectr.change', (option) => {
								log('option2', option);
								if (option) {
									let record = recordMap[option.value];

									nodes.school.value = record.school_name;
									nodes.address.value = record.pstreet_1;
									nodes.city.value = record.pcity;
									nodes.zip.value = record.pzip;

									log(record);
									for (let node in nodes) {
										log('node', node, nodes[node].value, nodes[node]);
									}
								}
							});
						}

						return select;
					}
					return null;
				}).filter((select) => typeof select !== null);
			}

			if (state && school && selectrs[state] && selectrs[schoolSelectName]) {
				selectrs[state].on('selectr.change', (option) => {
					const label = document.querySelector(`label[for="${school}"]`);
					const stateVal = selectrs[state].getValue(true).text;

					selectrs[schoolSelectName].removeAll();

					if (cache[stateVal]) {
						selectrs[schoolSelectName].add(cache[stateVal]);
					} else {
						let xhr = new XMLHttpRequest();
						xhr.open('GET', `/wp-json/playworks/nces?state=${selectrs[state].getValue(true).text}`);
						xhr.addEventListener('load', () => {
							const response = JSON.parse(xhr.responseText);
							cache[stateVal] = response.map((record) => {
								recordMap[record.school_name] = record;
								return {
									value: record.school_name,
									text: [
										record.school_name,
										toTitleCase(record.pcity),
										toTitleCase(record.agency_name),
									].filter((str) => str && typeof str === 'string').join(' - ')
								};
							});

							selectrs[schoolSelectName].add(cache[stateVal]);
							selectrs[schoolSelectName].enable();

							let loading = label.parentNode.querySelector('.svg--loader');
							if (loading) {
								loading.parentNode.removeChild(loading);
							}
						});
						xhr.send();

						selectrs[schoolSelectName].disable();
						label.insertAdjacentHTML('afterend', loader);
					}
				});

				if (selectrs[state].getValue()) {
					selectrs[state].emit('selectr.change', selectrs[state].options[selectrs[state].selectedIndex]);
				}
			}

			const submit = form.querySelector('.primaryAction');
			if (submit) {
				//submit.type = 'hidden';
				submit.classList.add('primaryAction--hidden');

				const button = document.createElement('button');
				button.type = 'submit';
				button.classList.add('button');
				button.dataset.text = submit.value;
				//button.innerHTML = submit.value.split('').map((char) => `<span>${char}</span>`).join('');
				button.innerHTML = submit.value.split('').map(char => {
					if (char === ' ') {
						char = '&nbsp;';
					}
					var newChar = `<span>${char}</span>`;
					return newChar;
				}).join('');
				submit.parentNode.insertBefore(button, submit.nextChild);
			}

			setTimeout(() => {
				const wfNext = form.querySelector('.wfPageNextButton');
				if (wfNext) {
					wfNext.classList.add('primaryAction--hidden');

					const button = document.createElement('button');
					button.type = 'button';
					button.classList.add('button');
					button.dataset.text = wfNext.value;
					//button.innerHTML = submit.value.split('').map((char) => `<span>${char}</span>`).join('');
					button.innerHTML = wfNext.value.split('').map(char => {
						if (char === ' ') {
							char = '&nbsp;';
						}
						var newChar = `<span>${char}</span>`;
						return newChar;
					}).join('');
					button.addEventListener('click', function () {
						wfNext.click();
					});
					wfNext.parentNode.insertBefore(button, wfNext.nextChild);

				}

				const wfPrev = form.querySelector('.wfPagePreviousButton');
				if (wfPrev) {
					wfPrev.classList.add('primaryAction--hidden');

					const button = document.createElement('button');
					button.type = 'button';
					button.classList.add('button');
					button.dataset.text = wfPrev.value;
					//button.innerHTML = submit.value.split('').map((char) => `<span>${char}</span>`).join('');
					button.innerHTML = wfPrev.value.split('').map(char => {
						if (char === ' ') {
							char = '&nbsp;';
						}
						var newChar = `<span>${char}</span>`;
						return newChar;
					}).join('');
					button.addEventListener('click', function () {
						wfPrev.click();
					});
					wfPrev.parentNode.insertBefore(button, wfPrev.nextChild);

				}
			}, 5000);

			if (form.dataset.formid) {
				const cookieName = 'STYXKEY-formid';

				log('formid', form.dataset.formid, 'cookie', Cookies.get(cookieName));
				if (form.querySelector('form')) {
					form.addEventListener('submit', () => {
						Cookies.set(cookieName, form.dataset.formid);
					});

				} else if (Cookies.get(cookieName) === form.dataset.formid && window.location.search.indexOf('tfa_next=') > -1) {
					log('remove cookie', form.dataset.formid);
					Cookies.remove(cookieName);
				}
			}

		});
	}

	footerNewsletter() {
		const form = document.querySelector('.footer--subscribe form');

		if (form && form instanceof HTMLFormElement && typeof form.checkValidity === 'function') {
			const validate = function () {
				let errMsg = this.parentNode.querySelector("small");
				this.classList.remove("invalid");

				if (errMsg) {
					errMsg.parentNode.removeChild(errMsg);
				}

				if (!this.checkValidity()) {
					errMsg = document.createElement("small");
					errMsg.appendChild(document.createTextNode(this.validationMessage));
					this.parentNode.appendChild(errMsg);
					this.classList.add("invalid");
					form.classList.add("invalid-form");
				}
			}

			form.setAttribute('novalidate', 'novalidate');
			form.addEventListener('submit', (e) => {
				if (form.checkValidity() === false) {
					e.preventDefault();

					["tfa_1", "tfa_12", "tfa_5", "tfa_3193"].forEach((field) => {
						validate.call(form[field]);
						form[field].addEventListener("change", validate);
					});
				}
			});
		}
	}

	analytics() {
		const downloadExtensions = /\.(docx?|pptx?|xlsx?|pdf|zip|jpe?g|png|gif)(\?.*|#.*)?$/; // Regex matching download extensions (ignoring query strings/hashes)

		const analyticsHandler = (e) => {
			let node = e.target;
			while (node.parentNode && node.tagName !== 'A') {
				node = node.parentNode;
			}

			if (!node || !node.parentNode) {
				console.log('no link');
				return;
			}

			e.data = { // Compat with MonsterInsights
				action: node.href,
				label: node.textContent.trim()
			};

			if (node.protocol && 'tel:' === node.protocol) {

				e.data.category = 'tel'; // Compat with MonsterInsights
				e.data.action = e.data.action.replace('tel:', '');

			} else if (node.protocol && 'mailto:' === node.protocol) {

				e.data.category = 'mailto'; // Compat with MonsterInsights
				e.data.action = e.data.action.replace('mailto:', '');

			} else if (node.hostname && node.hostname !== document.domain) {

				e.data.category = 'outbound-link'; // Compat with MonsterInsights

			} else if (node.href.match(downloadExtensions)) {

				e.data.category = 'download'; // Compat with MonsterInsights
			} else {

				// Regular internal link - do not track
				return;

			}

			return trackAllClicks(e);
		}

		'click mousedown'.split(' ').forEach(evt => document.addEventListener(evt, analyticsHandler));
	}
}

export default Site;
